var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjetosLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4599 49.9199C26.3999 49.9199 23.9399 47.3999 23.9399 44.3999C23.9399 41.3399 26.4599 38.8799 29.4599 38.8799H29.5799V37.5599C29.5799 33.5999 32.8799 30.4199 36.8999 30.4199C40.7999 30.4199 44.0399 33.4799 44.2199 37.3199H47.3399C50.6399 37.3199 53.2799 40.0199 53.2799 43.2599V43.9799C53.2799 47.2799 50.5799 49.9199 47.3399 49.9199H29.4599Z",
    fill: "url(#paint0_linear_4_167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4599 49.9199C26.3999 49.9199 23.9399 47.3999 23.9399 44.3999C23.9399 41.3399 26.4599 38.8799 29.4599 38.8799H29.5799V37.5599C29.5799 33.5999 32.8799 30.4199 36.8999 30.4199C40.7999 30.4199 44.0399 33.4799 44.2199 37.3199H47.3399C50.6399 37.3199 53.2799 40.0199 53.2799 43.2599V43.9799C53.2799 47.2799 50.5799 49.9199 47.3399 49.9199H29.4599Z",
    stroke: "#1E293B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6601 17.1601C12.9584 17.1601 13.2001 16.9183 13.2001 16.6201C13.2001 16.3218 12.9584 16.0801 12.6601 16.0801C12.3619 16.0801 12.1201 16.3218 12.1201 16.6201C12.1201 16.9183 12.3619 17.1601 12.6601 17.1601Z",
    stroke: "#55D055",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.82 17.1601C18.1183 17.1601 18.36 16.9183 18.36 16.6201C18.36 16.3218 18.1183 16.0801 17.82 16.0801C17.5218 16.0801 17.28 16.3218 17.28 16.6201C17.28 16.9183 17.5218 17.1601 17.82 17.1601Z",
    stroke: "#55D055",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71997 19.38V13.02C6.71997 11.88 7.67997 10.98 8.75997 10.98H34.8C35.94 10.98 36.84 11.88 36.84 13.02V27.24",
    stroke: "#1E293B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71997 30.8999V22.4399H36.84",
    stroke: "#1E293B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.82 45.3001H8.82003C7.68003 45.3001 6.78003 44.4001 6.78003 43.2601V33.8401H8.16003H26.88",
    stroke: "#1E293B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6601 28.62C12.9584 28.62 13.2001 28.3783 13.2001 28.08C13.2001 27.7818 12.9584 27.54 12.6601 27.54C12.3619 27.54 12.1201 27.7818 12.1201 28.08C12.1201 28.3783 12.3619 28.62 12.6601 28.62Z",
    stroke: "#1E293B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.82 28.62C18.1183 28.62 18.36 28.3783 18.36 28.08C18.36 27.7818 18.1183 27.54 17.82 27.54C17.5218 27.54 17.28 27.7818 17.28 28.08C17.28 28.3783 17.5218 28.62 17.82 28.62Z",
    stroke: "#1E293B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6601 39.9599C12.9584 39.9599 13.2001 39.7181 13.2001 39.4199C13.2001 39.1216 12.9584 38.8799 12.6601 38.8799C12.3619 38.8799 12.1201 39.1216 12.1201 39.4199C12.1201 39.7181 12.3619 39.9599 12.6601 39.9599Z",
    stroke: "#1E293B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.82 39.9599C18.1183 39.9599 18.36 39.7181 18.36 39.4199C18.36 39.1216 18.1183 38.8799 17.82 38.8799C17.5218 38.8799 17.28 39.1216 17.28 39.4199C17.28 39.7181 17.5218 39.9599 17.82 39.9599Z",
    stroke: "#1E293B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_167",
    x1: 23.9399,
    y1: 40.1699,
    x2: 53.2799,
    y2: 40.1699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjetosLogo);
export default __webpack_public_path__ + "static/media/projetos-logo.01197c6e9347edb45f452c1c3616c77b.svg";
export { ForwardRef as ReactComponent };